import React from 'react';

const Crop = ({ className }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 10.0283H12.7529" stroke="white" strokeLinecap="round" />
      <path d="M3.75879 12.7529L3.75879 1.00004" stroke="white" strokeLinecap="round" />
      <path d="M1 3.79297H12.7529" stroke="white" strokeLinecap="round" />
      <path d="M9.99512 12.8213L9.99512 1.0684" stroke="white" strokeLinecap="round" />
    </svg>
  )
}

export default Crop;